// Macquarie-style look for the website.
//
// The palette is Macquarie University's, sampled from mq.edu.au: the bright
// red carries the big brand surfaces (hero, page banners), the deeper red is
// for buttons and links, charcoal for the footer and headings, and a warm
// sand for the boxes and quiet sections. Cards sit on white or sand, never on
// red — red backgrounds are kept for the hero and page banners only.

export const C = {
  bright: "#D6001C", // hero, banners, card hover bar
  red: "#A6192E", // buttons, links, small red text
  redDark: "#76232F", // hover
  ink: "#373A36", // headings, footer
  body: "#4B4D49",
  muted: "#6E706B",
  sand: "#F7F6F2",
  line: "#E4E2DB",
  utility: "#2A2C2A",
  white: "#FFFFFF",
};

export const FONT = "'Montserrat', 'Helvetica Neue', Arial, sans-serif";

// Content column: 1024px wide, as on mq.edu.au.
export const container = { maxWidth: 1072, margin: "0 auto", padding: "0 24px" };

export const sectionTitle = {
  fontSize: 38,
  fontWeight: 700,
  color: C.ink,
  letterSpacing: "-0.3px",
  lineHeight: 1.2,
  textAlign: "center",
  margin: "0 0 14px",
};

export const sectionLead = {
  fontSize: 15,
  lineHeight: 1.75,
  color: C.body,
  textAlign: "center",
  maxWidth: 720,
  margin: "0 auto",
};
